import ConfirmModal from "PFComponents/confirm/confirm_modal";
import Toggle from "PFComponents/toggle/toggle";
import { getProfileName } from "PFCore/helpers/profile";
import { useErrorsGrowl } from "PFCore/hooks/use_errors_growl";
import { toggleVisiblity } from "PFCore/services/admin/users/toggle_visibility";
import PropTypes from "prop-types";
import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

const HideAction = ({ user, refetchUsers }) => {
  const { t } = useTranslation("admin", { keyPrefix: "users.list.actions" });

  const growlErrors = useErrorsGrowl();

  const isHidden = user.hidden;

  const [showModal, setShowModal] = useState(false);

  const handleHideUser = useCallback(() => {
    if (!isHidden) {
      setShowModal(true);
    } else {
      toggleHide();
    }
  }, [user, isHidden]);

  const toggleHide = () => {
    toggleVisiblity(user.id, isHidden).then(refetchUsers, (response) => growlErrors(response));
  };

  return (
    <>
      <Toggle
        qaId={`AdminActionButton.hide.${isHidden ? "isHidden" : "isVisible"}`}
        onChange={handleHideUser}
        checked={!isHidden}
        inline
      />
      {showModal && (
        <ConfirmModal handleOK={toggleHide} handleClose={() => setShowModal(false)}>
          {t("hideConfirm", { name: getProfileName(user) })}
        </ConfirmModal>
      )}
    </>
  );
};

HideAction.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    hidden: PropTypes.bool
  }),
  refetchUsers: PropTypes.func
};

export default HideAction;
